import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Helpers } from '../../../helpers';
import { Router } from '@angular/router';

declare let mLayout: any;
@Component({
  selector: 'app-header-nav',
  templateUrl: './header-nav.component.html',
  encapsulation: ViewEncapsulation.None
})
export class HeaderNavComponent implements OnInit, AfterViewInit {
  constructor(private _router: Router) {}
  ngOnInit() {}
  ngAfterViewInit() {
    mLayout.initHeader();
  }
  logout(): void {
    // clear token remove user from local storage
    localStorage.removeItem('currentUser');
    localStorage.clear();
    this._router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/layouts/header-nav/header-nav.component.ts